export const submitForm = async (data)=>{
    const headers = new Headers();
    headers.append('content-type', 'application/json');
    headers.append('X-XSRF-TOKEN', document.getElementsByName("__RequestVerificationToken")[0].value);
    const body = JSON.stringify(data);
    const response = await fetch('/api/v1/Newsletter/SignUp', {
        method: 'POST',
        headers,
        body
    });
    return response.ok;
};
